import { isNullOrEmpty } from './validation.util';

export function updateArrayItem<T, K extends keyof T>(
  arr: T[],
  key: T[K],
  keyName: keyof T,
  newObject: Partial<T>,
): T[] {
  let listUpdated: T[] = arr;
  if (!isNullOrEmpty(arr)) {
    // eslint-disable-next-line dot-notation
    const idx = arr.findIndex(item => item[keyName] === key);

    if (idx > -1) {
      listUpdated = [...arr];
      listUpdated.splice(idx, 1, {
        ...listUpdated[idx],
        ...newObject,
      });
    }
  }
  return listUpdated;
}
